import {jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";import styled from '@emotion/styled'
import clsx from 'clsx'
import useAtmosphere from '../hooks/useAtmosphere'
import useMutationProps from '../hooks/useMutationProps'
import useRouter from '../hooks/useRouter'
import logo from '../styles/theme/images/graphics/google.svg'
import GoogleClientManager from '../utils/GoogleClientManager'
import RaisedButton from './RaisedButton'
import StyledError from './StyledError'
import StyledTip from './StyledTip'








const helpText = {
  fontSize: '.8125rem',
  marginTop: '.5rem'
}

const ErrorMessage = styled(StyledError)({
  ...helpText
})

const HelpMessage = styled(StyledTip)({
  ...helpText
})

const GoogleOAuthButtonBlock = (props) => {
  const {invitationToken, isCreate, loginHint, getOffsetTop} = props
  const {onError, error, submitting, onCompleted, submitMutation} = useMutationProps()
  const atmosphere = useAtmosphere()
  const {history, location} = useRouter()
  const label = isCreate ? 'Sign up with Google' : 'Sign in with Google'
  const openOAuth = () => {
    const mutationProps = {onError, onCompleted, submitMutation, submitting}
    GoogleClientManager.openOAuth(
      atmosphere,
      mutationProps,
      history,
      location.search,
      invitationToken,
      loginHint,
      getOffsetTop
    )
  }
  return (
    _jsxs(_Fragment, { children: [
      _jsxs(RaisedButton, {
        onClick: openOAuth,
        waiting: submitting,
        className: clsx(
          'mt-4 h-10 w-60 justify-start px-4 disabled:opacity-100',
          submitting ? 'bg-slate-300 text-slate-600' : 'bg-white text-slate-700'
        ),
 children: [
        _jsx('img', { src: logo, className: clsx('mx-4 h-[18px] w-[18px]', submitting && 'contrast-0'),} )
        , _jsx('div', { children: label})
      ]})
      , error && !submitting && _jsx(ErrorMessage, { children: error.message})
      , submitting && _jsx(HelpMessage, { children: "Continue through the login popup"    })
    ]})
  )
}

export default GoogleOAuthButtonBlock
